import {fetchBody, URL_RECUITMENTPERFORMANCECONTRACTORRELATED_GET_DETAIL, URL_RECUITMENTPERFORMANCE_GET_COUNT, URL_RECUITMENTPERFORMANCECONTRACTOR_DEPARTMENT_GET_LIST, URL_RECUITMENTPERFORMANCECONTRACTOR_SPECIALIST_GET_LIST, URL_RECUITMENTPERFORMANCECONTRACTOR_RELATED_GET_LIST} from "../config"
import { toLogout, cleanFetch } from "./apiTools";
import { getToken } from "../component/Login/Auth";

export function api_getRecruitmentPerformanceCount ({mReqRecruitmentPerformanceCount, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqRecruitmentPerformanceCount, token}), 
      url: URL_RECUITMENTPERFORMANCE_GET_COUNT, 
      success,
      failure
    })
  }
}

export function api_getRecruitmentPerformanceContractorDepartmentList ({mReqRecruitmentPerformanceDepartmentList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqRecruitmentPerformanceDepartmentList, token}), 
      url: URL_RECUITMENTPERFORMANCECONTRACTOR_DEPARTMENT_GET_LIST, 
      success,
      failure
    })
  }
}

export function api_getRecruitmentPerformanceContractorSpecialistList ({mReqRecruitmentPerformanceSpecialistList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqRecruitmentPerformanceSpecialistList, token}), 
      url: URL_RECUITMENTPERFORMANCECONTRACTOR_SPECIALIST_GET_LIST, 
      success,
      failure
    })
  }
}

export function api_getRecruitmentPerformanceContractorRelatedList ({mReqRecruitmentPerformanceContractorRelatedList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqRecruitmentPerformanceContractorRelatedList, token}), 
      url: URL_RECUITMENTPERFORMANCECONTRACTOR_RELATED_GET_LIST, 
      success,
      failure
    })
  }
}


export function api_getRecruitmentPerformanceContractorRelatedDetail ({mReqRecruitmentContractorDetail, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqRecruitmentContractorDetail, token}), 
      url: URL_RECUITMENTPERFORMANCECONTRACTORRELATED_GET_DETAIL, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}
